export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-287e0531893c97df27e7.worker.js");
}
